import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs';
import '../distributer/distributer.css';
import DistributorList from '../distributer/distributerList/DistributerList';
import KycDetailsFilter from './KycDetailsFilter';
import {
    reailerDistIdAgainstFillers,
    reailerDistIdExcel,
    updateDistributerApproval,
    updateUser
} from '../../api/login/Login';
import { toast } from 'react-toastify';

function KycDetails() {
    const params = useParams();
    const status = params?.status || 'not-verified';
    const isVerified = status === 'verified';
    const currentKycStatus = isVerified ? 'verified' : 'unverified';

    const [state, setState] = useState({ user: [], totalCount: 0 });
    const [excelData, setExcelData] = useState([]);
    const [filterKey, setFilterKey] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const count = 10;
    const [approval, setApproveVal] = useState(null);

    const getExcelData = async (currentFilters = filterKey) => {
        try {
            const queryParams = {
                page: 0,
                count: 10000,
                kycStatus: currentKycStatus,
                is_approved: currentKycStatus,
                mobile: currentFilters?.mobile ? currentFilters.mobile.slice(3) : '',
                id: currentFilters?.user_type_id || '',
                name: currentFilters?.name || '',
                email: currentFilters?.email || '',
                refer_id: currentFilters?.refer_id || '',
            };
            const res = await reailerDistIdExcel(queryParams);
            setExcelData(res?.data || []);
        } catch (error) {
            setExcelData([]);
        }
    };

    const fetchKycList = async (pageNumber = 0, currentFilters = filterKey) => {
        setLoading(true);
        try {
            const queryParams = {
                page: pageNumber,
                count: count,
                kycStatus: currentKycStatus,
                is_approved: currentKycStatus,
                mobile: currentFilters?.mobile ? currentFilters.mobile.slice(3) : '',
                id: currentFilters?.user_type_id || '',
                name: currentFilters?.name || '',
                email: currentFilters?.email || '',
                refer_id: currentFilters?.refer_id || '',
            };
            const res = await reailerDistIdAgainstFillers(queryParams);
            setState(res?.data || { user: [], totalCount: 0 });
        } catch (error) {
            console.error("Error loading KYC list:", error);
            setState({ user: [], totalCount: 0 });
        } finally {
            setLoading(false);
        }
    };

    const submitForm = async (values) => {
        setFilterKey(values);
        setPage(0);
        fetchKycList(0, values);
        getExcelData(values);
    };

    const onChangeVal = (newPage) => {
        const targetPage = newPage - 1;
        setPage(targetPage);
        fetchKycList(targetPage, filterKey);
    };

    useEffect(() => {
        setPage(0);
        setFilterKey(null);
        fetchKycList(0, null);
        getExcelData(null);
    }, [status]);

    const toastSuccessMessage = () => {
        toast.success(`Status Updated Successfully.`, {
            position: "top-center",
        });
    };

    const errorMessage = () => {
        toast.error(`Status Not Updated.`, {
            position: "top-center"
        });
    };

    const handleChange = async (e, id) => {
        const val = e.target.value;
        setLoading(true);
        try {
            const res = await updateDistributerApproval({ is_approved: val }, id);
            if (res && res.statusCode === "200") {
                setApproveVal(val);
                toastSuccessMessage();
                fetchKycList(page, filterKey);
            } else {
                errorMessage();
            }
        } catch (error) {
            console.error(error);
            errorMessage();
        } finally {
            setLoading(false);
        }
    };

    const updateActiveStatus = async (item) => {
        setLoading(true);
        const body = {
            refer_id: item?.refer_id,
            status: !item?.status
        };
        try {
            await updateUser(item?._id, body);
            fetchKycList(page, filterKey);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const breadCrumbsTitle = {
        id: "1",
        title_1: "KYC Details",
        title_2: isVerified ? "Verified" : "Not Verified",
    };

    const listParams = {
        name: isVerified ? "Verified" : "Not Verified",
    };

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
            <KycDetailsFilter
                setPage={setPage}
                submitForm={submitForm}
                setFilterKey={setFilterKey}
                fetchKycList={fetchKycList}
                isVerified={isVerified}
            />
            <DistributorList
                updateActiveStatus={updateActiveStatus}
                loading={loading}
                params={listParams}
                state={state}
                excelData={excelData}
                handleChange={handleChange}
                onChangeVal={onChangeVal}
                approval={approval}
                getReailerDistIdAgainst={(p) => fetchKycList(p, filterKey)}
                submitForm={submitForm}
                initialValues={{}}
                page={page}
            />
        </>
    );
}

export default KycDetails;
